<div class="bg-th-blue mt-0 container-fluid py-2">

    <div class=" d-flex justify-content-between align-content-center">

        <i class="fa fa-arrow-left text-secondary my-auto pointer text-white" [routerLink]="['/']"></i>

        <a class=" d-flex align-items-center  text-secondary f18 my-auto text-white">

            <span> مدیریت فیلم‌ها </span>

        </a>

    </div>

</div>

<main class="py-4 px-2">

    <!-- فیلتر جستجو -->

    <form class="row gx-2 gy-md-0 gy-3" [formGroup]="mdl_Request">

        <!-- پارکینگ -->

        <div class="col-12 col-md-2 position-relative">

            <label class="mb-2 text-muted"> پارکینگ </label>

            <select class="form-select p-2" formControlName="iVS_Parking">

                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                <option class="text-center" *ngFor="let item of lst_Parking" [value]="item.iVS_Parking">

                    {{item.strName}}

                </option>

            </select>

        </div>

        <!-- خودرو -->

        <div class="col-12 col-md-2 position-relative">

            <label class="mb-2 text-muted"> خودرو </label>

            <select class="form-select p-2" formControlName="strUnitID">

                <option class="text-center" value=""> انتخاب کنید </option>

                <option class="text-center" *ngFor="let item of lst_Car" [value]="item.strUnitID">

                    {{item.strFullName}}

                </option>

            </select>

        </div>

        <!-- نوع فیلم -->

        <div class="col-12 col-md-2 position-relative">

            <label class="mb-2 text-muted"> نوع فیلم </label>

            <select class="form-select p-2" formControlName="tiMediaType">

                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                <option class="text-center" value="1"> رخداد‌ها </option>

                <option class="text-center" value="2"> کابین </option>

                <option class="text-center" value="3"> جاده </option>


            </select>

        </div>

        <!-- از تاریخ -->

        <div class=" col-12 col-md-2 position-relative">

            <label class="mb-2 text-muted"> از تاریخ </label>

            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

                <input formControlName="strSDate" class="form-control p-2 text-end" />

            </ng-persian-datepicker>

        </div>

        <!-- تا تاریخ -->

        <div class=" col-12 col-md-2 position-relative">

            <label class="mb-2 text-muted"> تا تاریخ </label>

            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

                <input formControlName="strEDate" class="form-control p-2 text-end" />

            </ng-persian-datepicker>

        </div>

        <!-- جستجو -->

        <div class="col-12 col-md-auto position-relative">

            <button class="btn btn-primary w-100 p-2" (click)="getReport()">

                &nbsp; جستجو &nbsp;

            </button>

        </div>

        <!-- نقشه -->

        <div class="col-12 col-md-auto position-relative" (click)="showMap_Cluster()">

            <button class="btn btn-warning w-100 p-2">

                &nbsp; نقشه &nbsp;

            </button>

        </div>

    </form>

    <!-- جدول اطلاعات -->

    <div class="border border-2 mt-3 p-2">

        <div class="row gx-2 gy-md-0 gy-3">

            <!-- فیلتر جستجو -->

            <div class="col-8">

                <input class="w-100 form-control" placeholder="جستجو کنید ..." (keyup)="filter_list($event.target)">

            </div>

            <!-- خروجی اکسل -->

            <div class="col-md-auto">

                <button class="btn btn-success p-2" (click)="Exportexcel('Export_Excel')">

                    &nbsp; خروجی اکسل &nbsp;

                </button>

            </div>

            <!-- پخش همه -->

            <ng-container *ngIf="lst_Ckecked.length > 0">

                <div class="col-md-auto">

                    <button class="btn btn-danger p-2" (click)="open_Playlist()">

                        &nbsp; پخش همه &nbsp;

                    </button>

                </div>

            </ng-container>

        </div>

        <div class="section border border-2 mt-2" style="height:calc(100vh - 220px);overflow: auto;">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead>

                    <tr class="">

                        <th class="text-center"> # </th>

                        <th class="text-center pointer" (click)="selectAllCheckBox()"> انتخاب </th>

                        <th class="text-center"> عملیات </th>

                        <th class="text-center"> پارکینگ </th>

                        <th class="text-center"> خودرو </th>

                        <th class="text-center"> کد </th>

                        <th class="text-center"> تاریخ </th>

                        <th class="text-center"> نوع </th>

                        <th class="text-center"> دوربین </th>

                    </tr>

                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of lst_Report;let i = index">

                        <th> {{ i + 1 | faNum }} </th>

                        <td class="pointer">

                            <input type="checkbox" (change)="setCheckBox($event.target.checked,item)" [checked]="isSelected(item.iVS_MediaIndex)">

                        </td>

                        <th class="">

                            <i class="fa fa-map-marker mx-2 fa-lg pointer" aria-hidden="true"
                                (click)="showMap(item)"></i>

                            <custom-map *ngIf="showCustom_Map" [strValue]="mdl_Map.get('strAddress')?.value"
                                [longLat]="[mdl_Map.get('fLon')?.value,mdl_Map.get('fLat')?.value]" [isOpenModal]="true"
                                [isView]="true" (mdl_Submit)="showCustom_Map=false">

                            </custom-map>

                            <i class="fa fa-play-circle fa-lg pointer" aria-hidden="true" (click)="openVideo(item)"></i>

                        </th>

                        <td>{{ item.strName | faNum }}</td>

                        <td>{{ item.strFullName | faNum }}</td>

                        <td>{{ item.iCode | faNum }}</td>

                        <td>{{ item.strDateTime | faNum}}</td>

                        <td>{{ item.strMediaType | faNum }}</td>

                        <td>{{ item.strCamera | faNum }}</td>

                    </tr>

                </tbody>

            </table>

        </div>

    </div>

    <!-- playlist-modal -->

    <div class="modal fade" id="playlist_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"  data-bs-keyboard="false" data-bs-backdrop='static'>

        <div class="modal-dialog">

            <div class="modal-content dirI">

                <div class="modal-header dirI">

                    <h5 class="modal-title" id="exampleModalLabel"> نمایش گروهی </h5>

                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="isPlaylist=false"></button>

                </div>

                <div class="modal-body">

                    <ng-container *ngIf="isPlaylist">

                        <playlist-player [playlist]="lst_Playlist"></playlist-player>

                    </ng-container>

                </div>

                <div class="modal-footer d-flex justify-content-start">

                    <button class="btn btn-outline-secondary" data-bs-dismiss="modal" (click)="isPlaylist=false">

                        &nbsp; بستن &nbsp;

                    </button>

                </div>

            </div>

        </div>

    </div>

</main>